import * as React from "react";
import { forwardRef } from "react";
const SvgFlagBlank = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.3999 14.4001V10.6221M2.3999 10.6221C6.4725 7.38659 9.5273 13.8575 13.5999 10.6221V2.5341C9.5273 5.76957 6.4725 -0.701373 2.3999 2.5341V10.6221Z", stroke: "#707577", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgFlagBlank);
export { ForwardRef as ReactComponent };
